// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BidItemPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type BidItemPageQuery = { __typename?: 'Query', bidItems: Array<{ __typename?: 'BidItem', code: string, id: string, name: string, products: Array<{ __typename?: 'Product', description?: string | null | undefined, sku?: string | null | undefined, upc?: string | null | undefined, id: string, name: string, images: Array<{ __typename?: 'Asset', id: string, downloadUrl: string }>, bidItems: Array<{ __typename?: 'BidItem', id: string, displayName: string }> }>, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string }, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string } }> };

export type BidItemPageOptionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type BidItemPageOptionsQuery = { __typename?: 'Query', attributes: Array<{ __typename?: 'ProductAttribute', id: string, value: string, type: Types.ProductAttributeType }>, products: Array<{ __typename?: 'Product', description?: string | null | undefined, sku?: string | null | undefined, upc?: string | null | undefined, id: string, name: string, images: Array<{ __typename?: 'Asset', id: string, downloadUrl: string }>, bidItems: Array<{ __typename?: 'BidItem', id: string, displayName: string }> }>, items: Array<{ __typename?: 'Item', displayName: string, id: string, name: string }>, unitsOfMeasure: Array<{ __typename?: 'UnitOfMeasure', id: string, name: string }>, costTypes: Array<{ __typename?: 'CostTypeDetail', code: Types.CostType, name: string }> };

export type BidItemDetailsFragment = { __typename?: 'BidItem', code: string, id: string, name: string, products: Array<{ __typename?: 'Product', description?: string | null | undefined, sku?: string | null | undefined, upc?: string | null | undefined, id: string, name: string, images: Array<{ __typename?: 'Asset', id: string, downloadUrl: string }>, bidItems: Array<{ __typename?: 'BidItem', id: string, displayName: string }> }>, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string }, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string } };

export type ProductAttributeFragment = { __typename?: 'ProductAttribute', id: string, value: string, type: Types.ProductAttributeType };

export type BidItem_ProductFragment = { __typename?: 'Product', description?: string | null | undefined, sku?: string | null | undefined, upc?: string | null | undefined, id: string, name: string, images: Array<{ __typename?: 'Asset', id: string, downloadUrl: string }>, bidItems: Array<{ __typename?: 'BidItem', id: string, displayName: string }> };

export type BidItemUnitsOfMeasureFragment = { __typename?: 'UnitOfMeasure', id: string, name: string };

export type BidItemCostTypeFragment = { __typename?: 'CostTypeDetail', code: Types.CostType, name: string };

export type BidItemItemsFragment = { __typename?: 'Item', displayName: string, id: string, name: string };

export type SaveBidItemMutationVariables = Types.Exact<{
  input: Types.SaveBidItemInput;
}>;


export type SaveBidItemMutation = { __typename?: 'Mutation', saveBidItem: { __typename?: 'SaveBidItemResult', bidItem: { __typename?: 'BidItem', code: string, id: string, name: string, products: Array<{ __typename?: 'Product', description?: string | null | undefined, sku?: string | null | undefined, upc?: string | null | undefined, id: string, name: string, images: Array<{ __typename?: 'Asset', id: string, downloadUrl: string }>, bidItems: Array<{ __typename?: 'BidItem', id: string, displayName: string }> }>, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string }, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string } } } };

export const BidItem_ProductFragmentDoc = gql`
    fragment BidItem_Product on Product {
  ...Named
  description
  sku
  upc
  images {
    id
    downloadUrl
  }
  bidItems {
    ...DisplayNamed
  }
}
    ${NamedFragmentDoc}
${DisplayNamedFragmentDoc}`;
export const BidItemDetailsFragmentDoc = gql`
    fragment BidItemDetails on BidItem {
  ...Named
  code
  products {
    ...BidItem_Product
  }
  unitOfMeasure {
    ...Named
  }
  costType {
    code
    name
  }
}
    ${NamedFragmentDoc}
${BidItem_ProductFragmentDoc}`;
export const ProductAttributeFragmentDoc = gql`
    fragment ProductAttribute on ProductAttribute {
  id
  value
  type
}
    `;
export const BidItemUnitsOfMeasureFragmentDoc = gql`
    fragment BidItemUnitsOfMeasure on UnitOfMeasure {
  ...Named
}
    ${NamedFragmentDoc}`;
export const BidItemCostTypeFragmentDoc = gql`
    fragment BidItemCostType on CostTypeDetail {
  code
  name
}
    `;
export const BidItemItemsFragmentDoc = gql`
    fragment BidItemItems on Item {
  ...Named
  displayName
}
    ${NamedFragmentDoc}`;
export const BidItemPageDocument = gql`
    query BidItemPage {
  bidItems {
    ...BidItemDetails
  }
}
    ${BidItemDetailsFragmentDoc}`;

/**
 * __useBidItemPageQuery__
 *
 * To run a query within a React component, call `useBidItemPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidItemPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidItemPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useBidItemPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BidItemPageQuery, BidItemPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidItemPageQuery, BidItemPageQueryVariables>(BidItemPageDocument, options);
      }
export function useBidItemPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidItemPageQuery, BidItemPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidItemPageQuery, BidItemPageQueryVariables>(BidItemPageDocument, options);
        }
export function useBidItemPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidItemPageQuery, BidItemPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidItemPageQuery, BidItemPageQueryVariables>(BidItemPageDocument, options);
        }
export type BidItemPageQueryHookResult = ReturnType<typeof useBidItemPageQuery>;
export type BidItemPageLazyQueryHookResult = ReturnType<typeof useBidItemPageLazyQuery>;
export type BidItemPageSuspenseQueryHookResult = ReturnType<typeof useBidItemPageSuspenseQuery>;
export type BidItemPageQueryResult = Apollo.QueryResult<BidItemPageQuery, BidItemPageQueryVariables>;
export const BidItemPageOptionsDocument = gql`
    query BidItemPageOptions {
  attributes(filter: {type: [BRAND]}) {
    ...ProductAttribute
  }
  products {
    ...BidItem_Product
  }
  items {
    ...BidItemItems
  }
  unitsOfMeasure {
    ...BidItemUnitsOfMeasure
  }
  costTypes {
    ...BidItemCostType
  }
}
    ${ProductAttributeFragmentDoc}
${BidItem_ProductFragmentDoc}
${BidItemItemsFragmentDoc}
${BidItemUnitsOfMeasureFragmentDoc}
${BidItemCostTypeFragmentDoc}`;

/**
 * __useBidItemPageOptionsQuery__
 *
 * To run a query within a React component, call `useBidItemPageOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidItemPageOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidItemPageOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBidItemPageOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BidItemPageOptionsQuery, BidItemPageOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidItemPageOptionsQuery, BidItemPageOptionsQueryVariables>(BidItemPageOptionsDocument, options);
      }
export function useBidItemPageOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidItemPageOptionsQuery, BidItemPageOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidItemPageOptionsQuery, BidItemPageOptionsQueryVariables>(BidItemPageOptionsDocument, options);
        }
export function useBidItemPageOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidItemPageOptionsQuery, BidItemPageOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidItemPageOptionsQuery, BidItemPageOptionsQueryVariables>(BidItemPageOptionsDocument, options);
        }
export type BidItemPageOptionsQueryHookResult = ReturnType<typeof useBidItemPageOptionsQuery>;
export type BidItemPageOptionsLazyQueryHookResult = ReturnType<typeof useBidItemPageOptionsLazyQuery>;
export type BidItemPageOptionsSuspenseQueryHookResult = ReturnType<typeof useBidItemPageOptionsSuspenseQuery>;
export type BidItemPageOptionsQueryResult = Apollo.QueryResult<BidItemPageOptionsQuery, BidItemPageOptionsQueryVariables>;
export const SaveBidItemDocument = gql`
    mutation SaveBidItem($input: SaveBidItemInput!) {
  saveBidItem(input: $input) {
    bidItem {
      ...BidItemDetails
    }
  }
}
    ${BidItemDetailsFragmentDoc}`;
export type SaveBidItemMutationFn = Apollo.MutationFunction<SaveBidItemMutation, SaveBidItemMutationVariables>;

/**
 * __useSaveBidItemMutation__
 *
 * To run a mutation, you first call `useSaveBidItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBidItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBidItemMutation, { data, loading, error }] = useSaveBidItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveBidItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveBidItemMutation, SaveBidItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveBidItemMutation, SaveBidItemMutationVariables>(SaveBidItemDocument, options);
      }
export type SaveBidItemMutationHookResult = ReturnType<typeof useSaveBidItemMutation>;
export type SaveBidItemMutationResult = Apollo.MutationResult<SaveBidItemMutation>;
export type SaveBidItemMutationOptions = Apollo.BaseMutationOptions<SaveBidItemMutation, SaveBidItemMutationVariables>;